"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _elementLocator = require("../../../core/utils/elementLocator");
var _excluded = ["children", "className", "HeadingType", "inheritedStyles", "elementLocator"];
var Heading = function Heading(_ref) {
  var children = _ref.children,
    className = _ref.className,
    HeadingType = _ref.HeadingType,
    inheritedStyles = _ref.inheritedStyles,
    elementLocator = _ref.elementLocator,
    others = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded);
  return _react.default.createElement(HeadingType, (0, _extends2.default)({
    className: className,
    "data-locator": elementLocator || "heading-" + HeadingType + "-" + (0, _elementLocator.getLabelFromChildren)(children)
  }, others), children);
};
Heading.defaultProps = {
  className: '',
  HeadingType: 'h1',
  elementLocator: '',
  inheritedStyles: '',
  children: ''
};
var _default = Heading;
exports.default = _default;
module.exports = exports["default"];